import { Component, Input, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss']
})
export class EditorComponent implements OnInit, OnDestroy {
  @Input() editorControl: FormControl = new FormControl();
  @Input() requiredFlag: boolean = false;
  @Input() editorHeight: string = '100%';
  constructor(
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }

  ngOnDestroy(): void {
  }

  onChange($event: any): void {
    // console.log("onChange");
  }

  onPaste($event: any): void {
    // console.log("onPaste");
  }

}
